import {useEffect, useState} from 'react';

import {getAutoReloadAt, reloadToUpdate} from '../../../../../helpers/app-update';
import {useUpdateAvailable} from '../../../../../hooks/use-app-update';
import {useTranslation} from '../../../../../hooks/use-translation';

/** When the page reloads by itself: whole minutes, seconds in the last minute; once due, it waits for the operator. */
const AutoReloadCountdown = (): React.JSX.Element => {
    const t = useTranslation();
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const timer = window.setInterval(() => setNow(Date.now()), 1000);

        return () => window.clearInterval(timer);
    }, []);

    const seconds = Math.ceil((getAutoReloadAt() - now) / 1000);

    if (0 >= seconds) {
        return <>{t('update.reloadWhenIdle')}</>;
    }

    const time =
        60 > seconds ? t('update.seconds', {count: seconds}) : t('update.minutes', {count: Math.ceil(seconds / 60)});

    return <>{t('update.reloadIn', {time})}</>;
};

/** A newer version was deployed: offered as a reload, the page also reloads by itself a while later. */
export const TopNavUpdate = (): React.JSX.Element | null => {
    const t = useTranslation();

    return useUpdateAvailable() ? (
        // no icon: the icon font of the old build may already be gone (the button is out of the tab order, like before)
        <p className="top-bar-update" role="status">
            {t('update.available')} — <AutoReloadCountdown />
            <button type="button" className="button button-primary button-small" tabIndex={-1} onClick={reloadToUpdate}>
                {t('update.reloadNow')}
            </button>
        </p>
    ) : null;
};
